import script from "./TitleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleCard.vue?vue&type=script&setup=true&lang=js"

import "./TitleCard.vue?vue&type=style&index=0&id=6b91b7fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b91b7fa"]])

export default __exports__